/* eslint-disable react-hooks/exhaustive-deps */
import "react-calendar/dist/Calendar.css";
import "./Attendance.css";
import { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import { Card } from "react-bootstrap";
import Logo from "./assets/Logo.png";

const SelectBranch = ({ setBranchfromComp }) => {
  const [selectedBranch, setSelectedBranch] = useState({});
  const [fetchedBranchList, setFetchedBranchList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [theme] = useState(localStorage.getItem("theme"));

  // Handle changes when a checkbox is clicked
  const handleChange = (value) => {
    // This is for multiple

    setSelectedBranch((prev) => {
      const newState = { ...prev, [value]: !prev[value] };
      console.log("", newState);

      // Reset class and section when branch selection changes
      localStorage.removeItem("class");
      localStorage.removeItem("section");
      return newState;
    });

    // This is for single
    // Create a new object with only the selected branch set to true
    // const newState = { [value]: true };

    // Clear class and section selections
    localStorage.removeItem("class");
    localStorage.removeItem("section");

    // Update state
    // setSelectedBranch(newState);
  };

  // Load the selected branches from localStorage and set them in state
  useEffect(() => {
    const storedBranches = JSON.parse(localStorage.getItem("branch"));
    
    if (storedBranches) {
      setSelectedBranch(storedBranches);
    }
  }, []);

  // Save selected branches to localStorage whenever selectedBranch changes
  useEffect(() => {
    if (Object.keys(selectedBranch).length > 0) {
      localStorage.setItem("branch", JSON.stringify(selectedBranch));
    }
    setBranchfromComp(selectedBranch);
  }, [selectedBranch]);

  // Fetch the branch list from API
  useEffect(() => {
    async function getBranchList() {
      setIsLoading(true);
      const fd = new FormData();
      //   const res = await hitApi("teacher/teacherCurl", "getBranchDetails", fd);
      const res = await hitApi("branch/branchCurl", "getBranchDetailsAll", fd);

      if (res.success) {
        setIsLoading(false);
        setFetchedBranchList(res.data);
      } else {
        setIsLoading(false);
        setFetchedBranchList(res.data);
      }
    }
    getBranchList();
  }, []);

  return (
    <div
      style={{ maxHeight: "73vh", overflow: "hidden", overflowY: "auto" }}
      className="p-1 pb-5"
    >
      {isLoading ? (
        <>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-12 rounded-2"></span>
              </h5>
              <h5 className="card-text d-flex justify-content-between placeholder-glow">
                <span className="placeholder col-5 py-2 rounded-2"></span>
              </h5>
            </div>
          </div>
        </>
      ) : (
        fetchedBranchList.length > 0 &&
        fetchedBranchList?.map((ele) => (
          <label
            key={ele.id}
            className="cursor-pointer position-relative  col-12 p-2"
          >
            <input
              // type="radio"
              type="checkbox"
              id={ele.name}
              value={ele.id}
              checked={selectedBranch[ele.id] || false}
              onChange={() => {
                handleChange(ele.id);
              }}
              className="opacity-0 position-absolute"
            />
            <Card
              className={`p-1 flex flex-col absolute border transition-all rounded-4 duration-300 ${
                selectedBranch[ele.id]
                  ? "bg-primary-subtle shadow-sm border-white"
                  : "border-black"
              }`}
            >
              <Card.Body
                style={{ height: "6rem" }}
                className="d-flex justify-content-between align-items-center"
                px-1
              >
                <img src={Logo} alt="" width={55} />
                <p
                  className={`text-sm text-left ps-2 fw-medium m-0 text-gray-500 ${
                    theme === "dark"
                      ? selectedBranch[ele.id]
                        ? "text-black"
                        : "text-white"
                      : ""
                  }`}
                >
                  {ele.name}
                </p>
              </Card.Body>
            </Card>
          </label>
        ))
      )}
    </div>
  );
};

export default SelectBranch;
